export const isSafariBrowser = () => {
	const { userAgent } = navigator;

	return /Safari/.test(userAgent) && !/Chrome|CriOS|FxiOS/.test(userAgent);
};
